// eslint-disable-next-line import/no-anonymous-default-export
export default {
  textColor: "#272838",
  primaryColor: "#7D8491",
  secondaryColor: "#5D536B",
  tertiaryColor: "#989FCE",
  otherColor: "#C0C5C1",
};
